import 'angular:locale/data:de';
import 'zone.js';
import '@angular/localize/init';(globalThis.$localize ??= {}).locale = "de";
